import { createAction } from '../../utils/redux'
import { ActionsUnion } from '../../utils/types'
import { Hook, HookValidationParameters, HookValidationResult } from './types'

// actions
export const FETCH_HOOKS = 'hook/FETCH_HOOKS'
export const FETCH_HOOKS_SUCCESS = 'hook/SUCCESS'
export const FETCH_HOOKS_FAIL = 'hook/FETCH_HOOKS_FAIL'

export const START_HOOK_VALIDATION = 'hook/START_HOOK_VALIDATION'
export const UPDATE_HOOK_VALIDATION = 'hook/UPDATE_HOOK_VALIDATION'

export const UPDATE_NEW_HOOK = 'hook/UPDATE_NEW_HOOK'
export const RESET_NEW_HOOK = 'hook/RESET_NEW_HOOK'

export const START_SAVING_HOOK = 'hook/START_SAVING_HOOK'
export const SAVING_HOOK_SUCCESS = 'hook/SAVING_HOOK_SUCCESS'
export const SAVING_HOOK_FAIL = 'hook/SAVING_HOOK_FAIL'

export const FETCH_HOOK_INFO = 'hook/FETCH_HOOK_INFO'
export const FETCH_HOOK_INFO_SUCCESS = 'hook/FETCH_HOOK_INFO_SUCCESS'

export const START_DELETING_HOOK = 'hook/START_DELETING_HOOK'
export const DELETING_HOOK_SUCCESS = 'hook/DELETING_HOOK_SUCCESS'
export const DELETING_HOOK_FAIL = 'hook/DELETING_HOOK_FAIL'

export const HookActions = {
  fetchHooks: () => createAction(FETCH_HOOKS),
  fetchHooksSuccess: (hooks: Hook[]) => createAction(FETCH_HOOKS_SUCCESS, hooks),
  startHookValidation: (hook: HookValidationParameters) => createAction(START_HOOK_VALIDATION, { hook }),
  updateHookValidation: (result: HookValidationResult) => createAction(UPDATE_HOOK_VALIDATION, result),
  updateNewHook: (hook: HookValidationParameters) => createAction(UPDATE_NEW_HOOK, { hook }),
  resetNewHook: () => createAction(RESET_NEW_HOOK),
  startSavingHook: (hook: HookValidationParameters) => createAction(START_SAVING_HOOK, { hook }),
  savingHookSuccess: (hook: Hook) => createAction(SAVING_HOOK_SUCCESS, hook),
  fetchHookInfo: (entityId: string) => createAction(FETCH_HOOK_INFO, entityId),
  fetchHookInfoSuccess: (hook: Hook) => createAction(FETCH_HOOK_INFO_SUCCESS, { hook }),
  startDeletingHook: (entityId: number) => createAction(START_DELETING_HOOK, entityId),
  deletinggHookSuccess: () => createAction(DELETING_HOOK_SUCCESS)
}

export type HookActions = ActionsUnion<typeof HookActions>
